import {configureStore, getDefaultMiddleware, AnyAction} from '@reduxjs/toolkit';
import thunk, { ThunkAction } from 'redux-thunk';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import createRootReducer, {RootState} from './rootReducer';

export const history = createBrowserHistory();

const createStore = (preloadedState: any) => configureStore({
  reducer: createRootReducer(history),
  preloadedState,
  middleware: [
    ...getDefaultMiddleware({serializableCheck: false}), 
    thunk, 
    routerMiddleware(history)
  ]
});

export type AppStore = ReturnType<typeof createStore>;
export type AppThunk<T> = ThunkAction<Promise<T>, RootState, unknown, AnyAction>

export default createStore;
